import { render, staticRenderFns } from "./APP2.vue?vue&type=template&id=ed648c0c&scoped=true"
import script from "./APP2.vue?vue&type=script&lang=js"
export * from "./APP2.vue?vue&type=script&lang=js"
import style0 from "./APP2.vue?vue&type=style&index=0&id=ed648c0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed648c0c",
  null
  
)

export default component.exports